import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { ACTION_TYPES, useOfficialDiarySearchDispatch, useOfficialDiarySearchState } from "./official-diary-search-context";

export const useOfficialDiarySearchController = () => {
    const navigate = useNavigate();
    const dispatch = useOfficialDiarySearchDispatch();
    const state = useOfficialDiarySearchState();

    function handleOnChange(e: any) {
        let number = state.parameters.number;
        let year = state.parameters.year;
        let isClosed = state.parameters.isClosed;
        let clientId = state.parameters.clientId;

        if (e.target.name === "input-number") {
            number = e.target.value;
        }
        if (e.target.name === "input-year") {
            year = e.target.value;
        }
        if (e.target.name === "select-closed") {
            isClosed = e.target.value;
        }
        if (e.target.name === "select-client") {
            clientId = e.target.value;
        }

        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: { number, year, isClosed, clientId, page: 0 }
        });
    }

    function handleStartDateChange(newValue: any) {
        const newDate = newValue as moment.Moment;

        dispatch({
            type: ACTION_TYPES.setDatesParameters,
            payload: {
                starDatePicker: newDate,
                endDatePicker: state.datesParameters.endDatePicker
            }
        });

        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: { startDate: newDate.format("YYYY-MM-DD"), page: 0 }
        });
    }

    function handleEndDateChange(newValue: any) {
        const newDate = newValue as moment.Moment;

        dispatch({
            type: ACTION_TYPES.setDatesParameters,
            payload: {
                starDatePicker: state.datesParameters.starDatePicker,
                endDatePicker: newDate
            }
        });

        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: { endDate: newDate.format("YYYY-MM-DD"), page: 0 }
        });
    }

    function navigateToCreate() {
        navigate('/diario-oficial/publicar');
    }

    return {
        handleOnChange,
        handleStartDateChange,
        handleEndDateChange,
        navigateToCreate
    };
}
